import React, { useState, useEffect } from 'react';
import { useParams,useNavigate } from "react-router-dom";
import { SpinLoading, Result, Space, Tag } from 'antd-mobile'
import { request } from '@/utils'
import './index.scss';
const TOKENKEY='cx315_token'
const Atype_2026 = () => {
    const navigate = useNavigate()
    const params = useParams()
    const [loading, setLoading] = useState(true);
    const [bangm, setbangm] = useState([]);


localStorage.setItem('atype2026',JSON.stringify(params))
    useEffect(() => {
        async function getau() {
            const res = await request.post('/v2/p_type_2026', params)
            if(res.return_code==="success"){
                localStorage.setItem(TOKENKEY,JSON.stringify(res))
                 navigate('/Y26')
              }
            setbangm(res)
            setLoading(false)
        }

        getau()

    }, [params,navigate])
    return <>

        {loading && <div
            className='SpinLoading'>
            <Space justify='center' align='center' direction='vertical'>
                <SpinLoading color='primary' style={{ '--size': '48px' }} />
                <Tag
                    color='primary'
                    fill='outline'
                    style={{ '--border-radius': '6px' }}
                >
                    数据加载中...
                </Tag>
            </Space>
            <Space justify='center' block>

            </Space>



        </div>

        }


        {bangm.return_code === "F" && <Result
            status='warning'
            title={bangm.return_msg}
            // description='内容详情可折行，建议不超过两行建议不超过两行建议不超过两行'
        />
        }

    </>
}

export default Atype_2026;